/* HALO Startseite v017q: Scroll-Ebene fuer sections/halo-home-story.liquid.
   Ohne Bibliothek, eine requestAnimationFrame-Schleife. Ohne Skript und bei
   prefers-reduced-motion bleibt die Seite ruhig und vollstaendig sichtbar. */
(function () {
  var root = document.querySelector('[data-hx]');
  if (!root) return;

  var clamp = function (v, a, b) { a = a === undefined ? 0 : a; b = b === undefined ? 1 : b; return Math.min(b, Math.max(a, v)); };
  var range = function (v, a, b) { return clamp((v - a) / (b - a)); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var eo = function (t) { return 1 - Math.pow(1 - t, 3); };
  var qs = function (s, el) { return (el || root).querySelector(s); };
  var qsa = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var pin = function (el) { var r = el.getBoundingClientRect(), vh = window.innerHeight; return { p: clamp(-r.top / Math.max(1, r.height - vh)), r: r, vh: vh }; };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  /* Header-Hoehe und Hoehe des Stimmen-Kopfs als CSS-Variablen */
  var hdr = document.querySelector('[data-halo-header]');
  var vhead = qs('[data-hx-vhead]');
  var setHead = function () {
    if (hdr) root.style.setProperty('--head', hdr.offsetHeight + 'px');
    if (vhead) root.style.setProperty('--vhead', vhead.offsetHeight + 'px');
  };
  setHead();
  window.addEventListener('resize', setHead);
  window.addEventListener('load', setHead);

  /* Header ueber dem Hero: helle Schrift, danach massiv */
  var hero = qs('[data-hx="hero"]');
  if (hdr && hero) {
    var tone = function () {
      var over = hero.getBoundingClientRect().bottom > hdr.offsetHeight + 2;
      hdr.classList.toggle('is-stuck', !over);
      hdr.setAttribute('data-tone', over ? 'dark' : 'light');
    };
    window.addEventListener('scroll', tone, { passive: true });
    tone();
  }

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  root.classList.add('hx--motion');

  /* Woerter einzeln setzen */
  qsa('[data-hx-words]').forEach(function (el) {
    var words = el.textContent.trim().split(/\s+/);
    el.textContent = '';
    words.forEach(function (w, i) {
      var sp = document.createElement('span');
      sp.className = 'w';
      sp.textContent = w;
      el.appendChild(sp);
      if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
  });

  /* Einblenden, Masken, Bild-Aufdeckung */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
  qsa('.hx-reveal, .hx-mask, [data-hx-clip]').forEach(function (el) { io.observe(el); });

  var subs = [];
  var on = function (fn) { subs.push(fn); };

  /* 1 Hero: Bild zoomt auf, Schleier lichtet sich */
  if (hero) (function () {
    var img = qs('[data-hx-hero-img]', hero), veil = qs('[data-hx-veil]', hero), hint = qs('[data-hx-hint]', hero), last = -1;
    on(function () {
      var o = pin(hero);
      if (o.r.bottom < 0 || Math.abs(o.p - last) < 0.0005) return;
      last = o.p;
      var p = o.p;
      img.style.transform = 'scale(' + lerp(1.18, 1, eo(range(p, 0, 0.8))).toFixed(4) + ')';
      veil.style.opacity = lerp(1, 0.72, eo(range(p, 0, 0.6))).toFixed(3);
      if (hint) hint.style.opacity = (1 - range(p, 0, 0.15)).toFixed(3);
    });
  })();

  /* 2 Laufband mit Scroll-Tempo und Neigung */
  qsa('[data-hx="marquee"]').forEach(function (wrap) {
    var track = qs('[data-hx-track]', wrap), x = 0, lastY = window.scrollY, lastT = 0, v = 0, dir = -1;
    on(function (t) {
      var dt = lastT ? Math.min(0.1, (t - lastT) / 1000) : 1 / 60;
      lastT = t;
      var y = window.scrollY, dy = y - lastY;
      lastY = y;
      if (dy) dir = dy > 0 ? -1 : 1;
      v += (dy / Math.max(dt, 0.001) - v) * 0.1;
      var r = wrap.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      x += dir * (40 + Math.min(Math.abs(v), 3000) * 0.4) * dt;
      var half = track.scrollWidth / 2;
      if (half > 0) x = ((x % half) - half) % half;
      track.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0) skewX(' + clamp(-v / 250, -12, 12).toFixed(2) + 'deg)';
    });
  });

  /* 3 Bruecke: Wort fuer Wort */
  qsa('[data-hx-words]').forEach(function (el) {
    var ws = qsa('.w', el), n = ws.length, last = -1;
    on(function () {
      var r = el.getBoundingClientRect(), vh = window.innerHeight;
      if (r.bottom < 0 || r.top > vh) return;
      var k = range(vh * 0.85 - r.top, 0, r.height + vh * 0.3);
      if (Math.abs(k - last) < 0.002) return;
      last = k;
      ws.forEach(function (w, i) { w.style.opacity = (0.16 + 0.84 * clamp(k * n * 1.1 - i)).toFixed(3); });
    });
  });

  /* 4 Aussen und Innen: sechs Schritte, ab Schritt 4 Phase Innen */
  qsa('[data-hx="duo"]').forEach(function (sec) {
    var pts = qsa('[data-hx-pt]', sec), n = pts.length, count = qs('[data-hx-duocount]', sec), bar = qs('[data-hx-duobar]', sec), cur = -1, last = -1;
    on(function () {
      var o = pin(sec);
      if (o.r.bottom < 0 || o.r.top > o.vh || Math.abs(o.p - last) < 0.00005) return;
      last = o.p;
      var u = range(o.p, 0.04, 0.96);
      if (bar) bar.style.transform = 'scaleX(' + u.toFixed(4) + ')';
      var idx = clamp(Math.floor(u * n), 0, n - 1);
      if (idx === cur) return;
      cur = idx;
      pts.forEach(function (li, i) { li.classList.toggle('on', i === idx); });
      sec.classList.toggle('is-inner', idx >= n / 2);
      if (count) count.textContent = pad(idx + 1);
    });
  });

  /* 7 Programme: Linie fuellt sich, Stufen leuchten auf */
  qsa('[data-hx="path"]').forEach(function (box) {
    var line = qs('[data-hx-pathline]', box), steps = qsa('[data-hx-step]', box);
    on(function () {
      var vh = window.innerHeight, br = box.getBoundingClientRect();
      if (br.bottom < -100 || br.top > vh + 100) return;
      var prog = clamp((vh * 0.62 - br.top) / br.height);
      if (line) line.style.transform = 'scaleY(' + prog.toFixed(3) + ')';
      steps.forEach(function (s) { s.classList.toggle('on', s.getBoundingClientRect().top < vh * 0.72); });
    });
  });

  /* 8 Produkte: Filmrolle, nur ab 990 px angeheftet */
  qsa('[data-hx="reel"]').forEach(function (sec) {
    var track = qs('[data-hx-reeltrack]', sec), cards = qsa('.hx-prod', sec), bar = qs('[data-hx-reelbar]', sec), count = qs('[data-hx-reelcount]', sec), last = -1;
    on(function () {
      if (window.innerWidth < 990) { if (track.style.transform) { track.style.transform = ''; cards.forEach(function (c) { c.style.opacity = ''; }); } return; }
      var o = pin(sec);
      if (o.r.bottom < 0 || o.r.top > o.vh || Math.abs(o.p - last) < 0.00005) return;
      last = o.p;
      var vw = window.innerWidth, k = range(o.p, 0.06, 0.94);
      var travel = Math.max(0, track.offsetLeft + track.scrollWidth - vw * 0.94);
      track.style.transform = 'translate3d(' + (-k * travel).toFixed(1) + 'px,0,0)';
      var focus = vw * 0.62, best = Infinity, near = 0;
      cards.forEach(function (c, i) {
        var r = c.getBoundingClientRect(), off = (r.left + r.width / 2 - focus) / vw, a = clamp(Math.abs(off) * 1.4);
        c.style.opacity = (1 - a * 0.5).toFixed(3);
        if (Math.abs(off) < best) { best = Math.abs(off); near = i; }
      });
      if (bar) bar.style.transform = 'scaleX(' + k.toFixed(4) + ')';
      if (count) count.textContent = pad(near + 1);
    });
  });

  /* Parallaxe */
  qsa('[data-hx-par]').forEach(function (el) {
    var f = +el.getAttribute('data-hx-par');
    on(function () {
      var r = el.getBoundingClientRect(), vh = window.innerHeight;
      if (r.bottom < -150 || r.top > vh + 150) return;
      var off = r.top + r.height / 2 - vh / 2;
      el.style.transform = 'translate3d(0,' + (off * f).toFixed(1) + 'px,0)';
    });
  });

  /* Magazin: Bilder zoomen beim Hereinscrollen */
  qsa('[data-hx-zoomimg]').forEach(function (el) {
    var last = -1;
    on(function () {
      var r = el.getBoundingClientRect(), vh = window.innerHeight;
      if (r.bottom < 0 || r.top > vh) return;
      var k = eo(range(vh - r.top, 0, vh * 0.8));
      if (Math.abs(k - last) < 0.001) return;
      last = k;
      el.style.transform = 'scale(' + lerp(1.16, 1, k).toFixed(4) + ')';
    });
  });

  var loop = function (t) { for (var i = 0; i < subs.length; i++) subs[i](t); requestAnimationFrame(loop); };
  requestAnimationFrame(loop);
})();
